import React from 'react'
import {connect} from 'react-redux'

import Component from '../components/start'
import actions from '../actions/start'
import depositActions from '../actions/deposit'

class Container extends React.Component {
  render() {
    return <Component {...this.props}/>
  }

  static propTypes = {}
}

const mapStateToProps = state => {
  const data = state.ui.deposit.start
  return {
    isFetching: data.get('isFetching'),
    error: data.get('error'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    start: () => dispatch(actions.getTransaction()),
    nextStepFromStart: () => dispatch(depositActions.nextStepFromStart()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/deposit/containers/start.js